import { render, staticRenderFns } from "./emptyCart.partial.vue?vue&type=template&id=180f3cd5"
import script from "./emptyCart.partial.vue?vue&type=script&lang=js"
export * from "./emptyCart.partial.vue?vue&type=script&lang=js"
import style0 from "./emptyCart.partial.vue?vue&type=style&index=0&id=180f3cd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports